import { render } from "./SplitById.vue?vue&type=template&id=400bb1e9&scoped=true&lang=pug"
import script from "./SplitById.vue?vue&type=script&lang=js"
export * from "./SplitById.vue?vue&type=script&lang=js"

import "./SplitById.vue?vue&type=style&index=0&id=400bb1e9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-400bb1e9"]])

export default __exports__